import React, {useEffect, useState} from 'react';
import SentenceForm from "../../components/common/SentenceForm";
import Container from "@material-ui/core/Container";
import {useDispatch, useSelector, useStore} from "react-redux";
import {makeStyles} from "@material-ui/core";
import ScrollableAnchor from "react-scrollable-anchor";
import Radio from "@material-ui/core/Radio";
import clsx from "clsx";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import RadioGroup from "@material-ui/core/RadioGroup";
import TextField from "@material-ui/core/TextField";
import HouseAccordion from "../common/HouseAccordion";
import CommercialRentAccordion from "../common/CommercialRentAccordion";
import Button from "@material-ui/core/Button";
import {store} from "react-notifications-component";
import {DropzoneArea} from "material-ui-dropzone";
import {useRecoilState, useRecoilValue, useSetRecoilState} from "recoil";
import {
    answerState, intFileState,
    menuCheckSelector, rentFileState,
    rentState,
    selectedMenuItemState,
    surveyDataState, userState
} from "../../state/globalState";
import uuid from "react-uuid";
import {fileUploadToAzureStorage, findFilesByFileGcd} from "../../lib/api/file";
import DropzoneFileItem from "../common/DropzoneFileItem";
import { formatWithComma } from "../../utils/utils";
import { numberToKorean } from '../../utils/numberTokorean'

const useStyles = makeStyles(theme => ({
    root: {
        '&:hover': {
            backgroundColor: 'transparent',
        },
    },
    buttons: {
        display: 'flex',
        justifyContent: 'flex-end'
    },
    button: {
        marginTop: theme.spacing(1),
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        marginBottom: theme.spacing(1),
        borderRadius: 15,
        backgroundColor: "#1b6817",
        padding: '5px 30px',
        height: 35,
        fontSize: "15px",
        color: 'white',
        '&:hover': {
            backgroundColor: '#767676',
            color: '#ffffff'
        }
    },
    icon: {
        borderRadius: '50%',
        width: 16,
        height: 16,
        boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
        backgroundColor: '#f5f8fa',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
        '$root.Mui-focusVisible &': {
            outline: '2px auto rgba(19,124,189,.6)',
            outlineOffset: 2,
        },
        'input:hover ~ &': {
            backgroundColor: '#ebf1f5',
        },
        'input:disabled ~ &': {
            boxShadow: 'none',
            background: 'rgba(206,217,224,.5)',
        },
    },
    checkedIcon: {
        backgroundColor: '#1b6817',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
        '&:before': {
            display: 'block',
            width: 16,
            height: 16,
            backgroundImage: 'radial-gradient(#fff,#fff 28%,transparent 32%)',
            content: '""',
        },
        'input:hover ~ &': {
            backgroundColor: '#1b6817',
        },
    },
    textField: {
        width: 300
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120
    },
    selectEmpty: {
        marginTop: theme.spacing(2),
    },
    media: {
        height: 250,
        width: '100%'
    },
    accordionWrapper: {
        display: "flex",
        flexDirection: "column",
        gap: "4px",
        margin: "25px"
    },
    divider: {
        margin: "0 20px"
    },
    amountRow: {
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        flexWrap: 'wrap'
    },
    amountReading: {
        fontSize: '12px',
        color: '#666',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        maxWidth: '60%',
        position: 'relative',
        top: 10
    },
}));

/**
 * 설문 문항 컴포넌트
 */
const Survey10 = (props) => {
    const userInfo = useRecoilValue(userState);
    const surveyData = useRecoilValue(surveyDataState);
    const [answer, setAnswer] = useRecoilState(answerState);
    const [rent, setRent] = useRecoilState(rentState);
    const setSelectedMenuItem = useSetRecoilState(selectedMenuItemState);
    const setMenuCheck = useSetRecoilState(menuCheckSelector);
    const [rentFiles, setRentFiles] = useRecoilState(rentFileState);
    const classes = useStyles();
    const dispatch = useDispatch();
    const {house, commercial, houseChecklist, commercialChecklist} = rent;
    const rentYn = answer.rentYn;
    const houseCnt = answer.houseCnt;
    const storeCnt = answer.storeCnt;
    const preBizAmt = answer.preBizAmt;
    const preBizAmt01 = answer.preBizAmt_01;
    const preBizAmt02 = answer.preBizAmt_02;
    const preBizAmt03 = answer.preBizAmt_03;
    const midPrepAmt = answer.midPrepAmt;
    const optRentYn = answer.optRentYn;
    const [openSubQuestion, setOpenSubQuestion] = useState(rentYn === "1");

    let parentCompRef = props.compRef;
    const { setProcess } = props;

    const ref = props.compRef[11];

    const setFocus = () => {
        ref.focus();
    }

    const addRefs = (el, idx) => {
        parentCompRef[idx] = el;
    };

    const getFiles = async (admnNo, stdYear) => {
        const { data } = await findFilesByFileGcd(admnNo, stdYear);
        if (data.success) {
            const files = data.payload.filter((file) => (file.kognrFileGcd === "HC050004"))
            setRentFiles(files);
        }
    }

    useEffect(() => {
        setSelectedMenuItem('SURVEY_22');
        if(Object.keys(house).length === 1) {
            setMenuCheck(true);
        } else {
            setMenuCheck(false);
        }
    }, [house]);

    useEffect(() => {
        setSelectedMenuItem('SURVEY_23');
        if(Object.keys(commercial).length === 1) {
            setMenuCheck(true);
        } else {
            setMenuCheck(false);
        }
    }, [commercial]);

    const handleInputAnswer = (e, column) => {
        const { value, name } = e.target;
        const rel = surveyData[20].rel;

        if ("rentYn" === column) {
            setAnswer({
                ...answer,
                rentBusiRegYn: "0",
                [column]: value
            });

            setSelectedMenuItem('SURVEY_20');
            setMenuCheck(value !== '');
        } else if ("houseCnt" === column) {
            const onlyNums = value.replace(/[^0-9]/g, '');
            const toNum = Number(onlyNums);

            if (toNum.toString().length < 10) {
                setAnswer({
                    ...answer,
                    [column]: toNum.toString()
                });

                setSelectedMenuItem('SURVEY_21');
                setMenuCheck(onlyNums !== "" || storeCnt !== "");
            }

        } else if ("storeCnt" === column) {
            const onlyNums = value.replace(/[^0-9]/g, '');
            const toNum = Number(onlyNums);

            if (toNum.toString().length < 10) {
                setAnswer({
                    ...answer,
                    [column]: toNum.toString()
                });

                setSelectedMenuItem('SURVEY_21');
                setMenuCheck(houseCnt !== "" || onlyNums !== "");
            }

        } else if ("preBizAmt" === column) {
            const regexp = /\B(?=(\d{3})+(?!\d))/g;
            const onlyNums = value.replace(/[^0-9]/g, '');
            const toNum = Number(onlyNums);
            if (toNum.toString().length < 12) {
                const number = toNum.toString().replace(regexp, ',');
                setAnswer({
                    ...answer,
                    [column]: number
                });

                setSelectedMenuItem('SURVEY_24');
                setMenuCheck(value !== '');
            }

        } else if ("preBizAmt_01" === column) {
          const regexp = /\B(?=(\d{3})+(?!\d))/g;
          const onlyNums = value.replace(/[^0-9]/g, '');
          const toNum = Number(onlyNums);
          if (toNum.toString().length < 12) {
            const number = toNum.toString().replace(regexp, ',');
            setAnswer({
              ...answer,
              [column]: number
            });

            setSelectedMenuItem('SURVEY_24');
            setMenuCheck(value !== '');
          }

        } else if ("preBizAmt_02" === column) {
          const regexp = /\B(?=(\d{3})+(?!\d))/g;
          const onlyNums = value.replace(/[^0-9]/g, '');
          const toNum = Number(onlyNums);
          if (toNum.toString().length < 12) {
            const number = toNum.toString().replace(regexp, ',');
            setAnswer({
              ...answer,
              [column]: number
            });

            setSelectedMenuItem('SURVEY_24');
            setMenuCheck(value !== '');
          }

        } else if ("preBizAmt_03" === column) {
          const regexp = /\B(?=(\d{3})+(?!\d))/g;
          const onlyNums = value.replace(/[^0-9]/g, '');
          const toNum = Number(onlyNums);
          if (toNum.toString().length < 12) {
            const number = toNum.toString().replace(regexp, ',');
            setAnswer({
              ...answer,
              [column]: number
            });

            setSelectedMenuItem('SURVEY_24');
            setMenuCheck(value !== '');
          }

        } else if ("midPrepAmt" === column) {
            const regexp = /\B(?=(\d{3})+(?!\d))/g;
            const onlyNums = value.replace(/[^0-9]/g, '');
            const toNum = Number(onlyNums);

            if (toNum.toString().length < 12) {
                const number = toNum.toString().replace(regexp, ',');
                setAnswer({
                    ...answer,
                    [column]: number
                });

                setSelectedMenuItem('SURVEY_25');
                setMenuCheck(value !== '');
            }

        } else if ("optRentYn" === column) {
            setAnswer({
                ...answer,
                [column]: value
            });

            setSelectedMenuItem('SURVEY_26');
            setMenuCheck(value !== '');
        }

        if (rel !== undefined && name === 'true') {
            setOpenSubQuestion(false)
        } else if (rel !== undefined && name === 'false') {
            setOpenSubQuestion(true)
        }
    };

    const handleAddHouseButtonClick = () => {
        if (Object.keys(house).length >= houseCnt) {
            store.addNotification({
                title: "알림",
                message: "소유 주택수를 초과할 수 없습니다.",
                type: 'warning',
                insert: "top",
                container: "top-center",
                animationIn: ["animated", "flipInY"],
                animationOut: ["animated", "flipOutY"],
                dismiss: {
                    duration: 3000,
                    onScreen: false
                },
                width: 500
            });
            return;
        }

        const newHouseData = {
            ...rent,
            house: {
                ...rent.house,
                ["house-" + uuid()]: {
                    kognrRentCd: "HC051001",
                    taxAccntYn: "",
                    taxAccntNm: "",
                    taxAccntTelno: "",
                    rentAgentNm: "",
                    rentAgentZpcd: "",
                    rentAgentAddr: "",
                    rentAgentAddrDetls: "",
                    rentIncomeAmt: "",
                    rentDepositAmt: "",
                    jointYn: "",
                    shareRate: "",
                    stdMktAmt: "",
                    ddcArea: "",
                    bizRegYn: "",
                    rentBizYn: "",
                }
            }
        }
        setRent(newHouseData);
    };

    const handleRemoveHouseButtonClick = () => {
        const tmpData = { ...rent.house };
        houseChecklist.forEach((item) => {
            delete tmpData[item];
        });

        const newState = {
            ...rent,
            house: tmpData,
            houseChecklist: []
        }
        setRent(newState);
    }

    const handleAddCommercialButtonClick = () => {
        if (Object.keys(commercial).length >= storeCnt) {
            store.addNotification({
                title: "알림",
                message: "소유 상가수를 초과할 수 없습니다.",
                type: 'warning',
                insert: "top",
                container: "top-center",
                animationIn: ["animated", "flipInY"],
                animationOut: ["animated", "flipOutY"],
                dismiss: {
                    duration: 3000,
                    onScreen: false
                },
                width: 500
            });
            return;
        }

        const newCommercialData = {
            ...rent,
            commercial: {
                ...rent.commercial,
                ["commercial-" + uuid()]: {
                    kognrRentCd: "HC051002",
                    taxAccntYn: "",
                    taxAccntNm: "",
                    taxAccntTelno: "",
                    rentAgentNm: "",
                    rentAgentZpcd: "",
                    rentAgentAddr: "",
                    rentAgentAddrDetls: "",
                    rentIncomeAmt: "",
                    rentDepositAmt: "",
                    jointYn: "",
                    shareRate: "",
                }
            }
        }
        setRent(newCommercialData);
    };

    const handleRemoveCommercialButtonClick = () => {
        const tmpData = { ...rent.commercial };
        commercialChecklist.forEach((item) => {
            delete tmpData[item];
        });

        const newState = {
            ...rent,
            commercial: tmpData,
            commercialChecklist: []
        }
        setRent(newState);
    };

    const StyledRadio = (props) => {
        return (
            <Radio
                disableRipple
                color="default"
                checked={rentYn === props.value}
                checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
                icon={<span className={classes.icon} />}
                onChange={(e) => handleInputAnswer(e, 'rentYn')}
                {...props}
            />
        );
    };

    const StyledRadioOptRentYn = (props) => {
        return (
            <Radio
                key={'rent-' + props.key}
                disableRipple
                color="default"
                checked={optRentYn === props.value}
                checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
                icon={<span className={classes.icon} />}
                onChange={(e) => handleInputAnswer(e, 'optRentYn')}
                {...props}
            />
        );
    };

    const step20List = surveyData[20].text.map((item) => {
        // item.content = item.content.replace('$stdYear$', appStore.getState().user.userInfo.stdYear);

        return (
            <>
                <FormControlLabel key={'20-' + item.key} name={String(item.toggle)} value={item.key}
                                  control={<StyledRadio />} label={item.content}/>
            </>
        )
    });

    const step26List = surveyData[26].text.map((item, idx) => {
        // item.content = item.content.replace('$stdYear$', appStore.getState().user.userInfo.stdYear);

        return (
            <>
                <FormControlLabel key={'26-' + item.key} name={String(item.toggle)} value={item.key}
                                  control={<StyledRadioOptRentYn />} label={item.content}/>
            </>
        )
    });

    const isDisplay = openSubQuestion === true ? 'block' : 'none';

    const handleChange = async (files) => {
        if (!files || files.length === 0) return;

        setSelectedMenuItem('SURVEY_27');

        const opts = {
            stdYear: userInfo.stdYear,
            admnNo: userInfo.admnNo,
            attcFileBizGcd: "hc056002",
            kognrFileGcd: "HC050004",
        }

        for (const fileObj of files) {
            const { data } = await fileUploadToAzureStorage(fileObj, opts);
            if (data.success) {
                const { resultCode, resultMsg } = data.payload;
                if (resultCode === "0000") {
                    setMenuCheck(true);
                } else {
                    console.error("File upload failed:", resultMsg);
                }
            }
        }

        await getFiles(userInfo.admnNo, userInfo.stdYear);
    };

    return (
        <>
            <ScrollableAnchor id={"20"}>
                <div>
                <Container style={{background: 'transparent', marginBottom: '10px'}}>
                    <SentenceForm
                        title={surveyData[20].title}
                        // sentences={surveyData[20].questions}
                        sentences={[]}
                        step={20}
                    />
                    <FormControl component="fieldset" style={{margin: '10px 20px 0 25px'}}>
                        {/*<Divider />*/}
                        <RadioGroup defaultValue="0" aria-label="" name="" row>
                            {step20List}
                        </RadioGroup>
                        {/*<Divider />*/}
                    </FormControl>
                </Container>
                </div>
            </ScrollableAnchor>

            <ScrollableAnchor id={"21"}>
                <div style={{display: isDisplay}}>
                    <Container style={{background: 'transparent', marginBottom: '10px'}}>
                        <SentenceForm
                            title={surveyData[21].title}
                            sentences={surveyData[21].questions}
                            step={21}
                        />
                        <div className="textFieldContainer">
                            <label>1) 주택 </label>
                            <TextField
                                id="real-estate"
                                // type="number"
                                inputProps={{style: { textAlign: 'right', width: 80 }}}
                                variant="standard"
                                onChange={(e) => handleInputAnswer(e, 'houseCnt')}
                                value={houseCnt}
                            />
                            <span>채 (본인과 배우자 및 동거하는 가족이 단독 및 공동명의로 소유한 주택. 임대하지 않은 주택 포함)</span>
                            <br />
                            <label>2) 상가 </label>
                            <TextField
                                id="commercial-rent"
                                // type="number"
                                inputProps={{style: { textAlign: 'right', width: 80 }}}
                                variant="standard"
                                onChange={(e) => handleInputAnswer(e, 'storeCnt')}
                                value={storeCnt}
                            />
                            <span>채 (본인이 단독 또는 공동명의로 소유한 상가)</span>
                        </div>
                    </Container>
                </div>
            </ScrollableAnchor>

            <ScrollableAnchor id={"22"}>
                <div style={{display: isDisplay}}>
                    <Container style={{background: 'transparent', marginBottom: '10px'}}>
                        <SentenceForm
                            title={surveyData[22].title}
                            sentences={surveyData[22].questions}
                            step={22}
                        />
                        <div className="textFieldContainer">
                            <Button
                                variant="contained"
                                className={classes.button}
                                name='add-house'
                                onClick={handleAddHouseButtonClick}
                            >
                                추가
                            </Button>
                            <Button
                                variant="contained"
                                className={classes.button}
                                name='delete-house'
                                onClick={handleRemoveHouseButtonClick}
                            >
                                삭제
                            </Button>
                        </div>

                        {Object.keys(house).length > 0 && (
                            <div className={classes.accordionWrapper}>
                                {Object.keys(house).map((item, index) => (
                                    <HouseAccordion key={item} id={item} houseNo={index + 1} setProcess={setProcess} />
                                 ))}
                            </div>
                        )}
                    </Container>
                </div>
            </ScrollableAnchor>

            <ScrollableAnchor id={"23"}>
                <div style={{display: isDisplay}}>
                    <Container style={{background: 'transparent', marginBottom: '10px'}}>
                        <SentenceForm
                            title={surveyData[23].title}
                            sentences={surveyData[23].questions}
                            step={23}
                        />
                        <div className="textFieldContainer">
                            <Button
                                variant="contained"
                                className={classes.button}
                                name='add-commercial'
                                onClick={handleAddCommercialButtonClick}
                            >
                                추가
                            </Button>
                            <Button
                                variant="contained"
                                className={classes.button}
                                name='delete-commercial'
                                onClick={handleRemoveCommercialButtonClick}
                            >
                                삭제
                            </Button>
                        </div>

                        {Object.keys(commercial).length > 0 && (
                            <div className={classes.accordionWrapper}>
                                {Object.keys(commercial).map((item, index) => (
                                    <CommercialRentAccordion key={item} id={item} commercialNo={index + 1} setProcess={setProcess} />
                                ))}
                            </div>
                        )}
                    </Container>
                </div>
            </ScrollableAnchor>

            <ScrollableAnchor id={"24"}>
                <div style={{display: isDisplay}}>
                    <Container style={{background: 'transparent', marginBottom: '10px'}}>
                        <SentenceForm
                            title={surveyData[24].title}
                            sentences={surveyData[24].questions}
                            step={24}
                        />
                      <Container>
                        <SentenceForm
                          title={surveyData[121].title}
                          sentences={surveyData[121].questions}
                          step={121}
                        />
                        <div className="textFieldContainer">
                          <div className={classes.amountRow}>
                            <TextField
                              key={'preBizAmt'}
                              className={classes.textField}
                              label="여기에 답변을 입력하십시오."
                              margin="none"
                              value={formatWithComma(String(preBizAmt).replace(/,/g, ''))}
                              onChange={(e) => handleInputAnswer(e, 'preBizAmt')}
                              inputRef={(el) => addRefs(el, 121)}
                              inputProps={{
                                style: { textAlign: 'right' },
                                inputMode: 'numeric'
                              }}
                            />
                            {String(preBizAmt).replace(/[^0-9]/g, '') && (
                              <span
                                className={classes.amountReading}
                                style={{ alignSelf: 'center' }}
                                title={numberToKorean(String(preBizAmt).replace(/[^0-9]/g, ''))}
                              >
                                {numberToKorean(String(preBizAmt).replace(/[^0-9]/g, ''))}
                              </span>
                            )}
                          </div>
                        </div>
                        <SentenceForm
                          title={surveyData[122].title}
                          sentences={surveyData[122].questions}
                          step={122}
                        />
                        <div className="textFieldContainer">
                          <div className={classes.amountRow}>
                            <TextField
                              key={'preBizAmt_01'}
                              className={classes.textField}
                              label="여기에 답변을 입력하십시오."
                              margin="none"
                              value={formatWithComma(String(preBizAmt01).replace(/,/g, ''))}
                              onChange={(e) => handleInputAnswer(e, 'preBizAmt_01')}
                              inputRef={(el) => addRefs(el, 122)}
                              inputProps={{
                                style: { textAlign: 'right' },
                                inputMode: 'numeric'
                              }}
                            />
                            {String(preBizAmt01).replace(/[^0-9]/g, '') && (
                              <span
                                className={classes.amountReading}
                                style={{ alignSelf: 'center' }}
                                title={numberToKorean(String(preBizAmt01).replace(/[^0-9]/g, ''))}
                              >
                                {numberToKorean(String(preBizAmt01).replace(/[^0-9]/g, ''))}
                              </span>
                            )}
                          </div>
                        </div>
                        <SentenceForm
                          title={surveyData[123].title}
                          sentences={surveyData[123].questions}
                          step={123}
                        />
                        <div className="textFieldContainer">
                          <div className={classes.amountRow}>
                            <TextField
                              key={'preBizAmt_02'}
                              className={classes.textField}
                              label="여기에 답변을 입력하십시오."
                              margin="none"
                              value={formatWithComma(String(preBizAmt02).replace(/,/g, ''))}
                              onChange={(e) => handleInputAnswer(e, 'preBizAmt_02')}
                              inputRef={(el) => addRefs(el, 123)}
                              inputProps={{
                                style: { textAlign: 'right' },
                                inputMode: 'numeric'
                              }}
                            />
                            {String(preBizAmt02).replace(/[^0-9]/g, '') && (
                              <span
                                className={classes.amountReading}
                                style={{ alignSelf: 'center' }}
                                title={numberToKorean(String(preBizAmt02).replace(/[^0-9]/g, ''))}
                              >
                                {numberToKorean(String(preBizAmt02).replace(/[^0-9]/g, ''))}
                              </span>
                            )}
                          </div>
                        </div>
                        <SentenceForm
                          title={surveyData[124].title}
                          sentences={surveyData[124].questions}
                          step={124}
                        />
                        <div className="textFieldContainer">
                          <div className={classes.amountRow}>
                            <TextField
                              key={'preBizAmt_03'}
                              className={classes.textField}
                              label="여기에 답변을 입력하십시오."
                              margin="none"
                              value={formatWithComma(String(preBizAmt03).replace(/,/g, ''))}
                              onChange={(e) => handleInputAnswer(e, 'preBizAmt_03')}
                              inputRef={(el) => addRefs(el, 123)}
                              inputProps={{
                                style: { textAlign: 'right' },
                                inputMode: 'numeric'
                              }}
                            />
                            {String(preBizAmt03).replace(/[^0-9]/g, '') && (
                              <span
                                className={classes.amountReading}
                                style={{ alignSelf: 'center' }}
                                title={numberToKorean(String(preBizAmt03).replace(/[^0-9]/g, ''))}
                              >
                                {numberToKorean(String(preBizAmt03).replace(/[^0-9]/g, ''))}
                              </span>
                            )}
                          </div>
                        </div>
                      </Container>
                    </Container>
                </div>
            </ScrollableAnchor>

          <ScrollableAnchor id={'25'}>
            <div style={{ display: isDisplay }}>
            <Container style={{background: 'transparent', marginBottom: '10px'}}>
                        <SentenceForm
                            title={surveyData[25].title}
                            sentences={surveyData[25].questions}
                            step={25}
                        />
                        <div className="textFieldContainer">
                            <TextField
                                key={'midPrepAmt'}
                                className={classes.textField}
                                label="금액"
                                placeholder=""
                                margin="none"
                                value={midPrepAmt}
                                onChange={(e) => handleInputAnswer(e, 'midPrepAmt')}
                                inputRef={(el) => addRefs(el, 25)}
                                inputProps={{
                                  style: { textAlign: 'right' },
                                  inputMode: 'numeric'
                                }}
                            />
                          {String(midPrepAmt).replace(/[^0-9]/g, '') && (
                            <span
                              className={classes.amountReading}
                              style={{ alignSelf: 'center' }}
                              title={numberToKorean(String(midPrepAmt).replace(/[^0-9]/g, ''))}
                            >
                                {numberToKorean(String(midPrepAmt).replace(/[^0-9]/g, ''))}
                              </span>
                          )}
                        </div>
                    </Container>
                </div>
            </ScrollableAnchor>

            <ScrollableAnchor id={"26"}>
                <div style={{display: isDisplay}}>
                    <Container style={{background: 'transparent', marginBottom: '10px'}}>
                        <SentenceForm
                            title={surveyData[26].title}
                            sentences={surveyData[26].questions}
                            step={26}
                        />
                        <FormControl component="fieldset" style={{margin: '10px 20px 0 25px'}}>
                            <RadioGroup defaultValue="0" aria-label="" name="">
                                {step26List}
                            </RadioGroup>
                        </FormControl>
                    </Container>
                </div>
            </ScrollableAnchor>

            <ScrollableAnchor id={"27"}>
                <div style={{display: isDisplay}}>
                    <Container style={{background: 'transparent', marginBottom: '10px'}}>
                        <SentenceForm
                            title={surveyData[27].title}
                            sentences={surveyData[27].questions}
                            step={27}
                        />
                        <div>
                            <div>
                              <div className="blockquote-box">
                                <div>
                                  [첨부파일 예시]
                                </div>
                                <div>
                                  1) 2025년도 귀속 1기 2기 부가가치세 신고서 사본 ( 국세청 다운로드시 정보 공개여부 "여"로 체크 필요)
                                </div>
                                <div>
                                  2) 임대사업자 등록을 하신 경우, 사업자등록증, 임대사업자 등록증 사본 (세무서, 관할 시•군•구청 등록증) 모두
                                  업로드 필요)
                                </div>
                                <div>
                                  3) 공동사업자 소득분배명세서(배우자가 아닌 자와 공동소유한 부동산을 임대한 경우)
                                </div>
                                <div>
                                  4) 중간예납 납부영수증 (선택사항)
                                </div>
                                <div>
                                  5) 종합소득세 신고 안내문 (선택사항)
                                </div>
                                <div>
                                  6) 간편장부 소득금액계산서, 총수입금액 및 필요경비명세서(간편장부를 작성한 경우)
                                </div>
                                <div>
                                  7) 총수입금액조정명세서, 조정후총수입금액명세서, 조정계산서, 과목별 소득금액조정명세서, 소득금액조정합계표, 표준합계잔액시산표, 표준손익계산서, 표준재무상태표(복식부기를 작성한 경우)
                                </div>
                                <div>
                                  <br/>
                                  파일형식 : 이미지파일(*.jpg, *.png), PDF파일, Office문서(*.xlsx, *.docx), ZIP파일
                                </div>
                              </div>
                              <br/>
                              <div style={{ marginLeft: '25px' }}>
                              <DropzoneArea
                                        acceptedFiles={[
                                            'application/pdf',
                                            'image/jpeg',
                                            'image/png',
                                            'application/vnd.ms-excel',
                                            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                                            'application/msword',
                                            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                                            'application/zip',
                                            '.hwp'
                                        ]}
                                        filesLimit={20}
                                        dropzoneText={'파일을 선택하거나 또는 여기로 끌어 주세요.'}
                                        maxFileSize={30000000}
                                        // showFileNames={true}
                                        showPreviewsInDropzone={false}
                                        showAlerts={false}
                                        onDrop={handleChange}
                                        // onDelete={handleDelete}
                                        // initialFiles={rentFile && rentFile.map((file) => file.name)}
                                    />
                                    {rentFiles && rentFiles.map((file) => <DropzoneFileItem {...file} />)}
                                </div>
                            </div>
                        </div>
                    </Container>
                </div>
            </ScrollableAnchor>
        </>
    );
};

export default Survey10;
